import React from "react";
import MUIDataTable from "mui-datatables";

// import Cities from "./cities";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const getMuiTheme = () => createMuiTheme({
  overrides: {
    MUIDataTableBodyCell: {
      root: {
        paddingLeft: '5px',
        paddingRight: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
      }
    },
    MUIDataTableHeadCell: {
      root: {
        paddingLeft: '5px',
        paddingRight: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
      }
    }
  }
})

class App extends React.Component {
  state = {
    theme: getMuiTheme()
  }

  render() {
    const { data, onClick, selected, rowsPerPage } = this.props
    // console.log(data)

    const columns = [
      {
        name: "event_id",
        label: "ID",
        options: {
          filter: false
        }
      },

      {
        name: 'comment',
        label: "Comment",
        options: {
          filter: false,
          display: false
        }
      // },

      },
      {
        name: 'status',
        label: "Status",
        options: {

          searchable: false,
          display: true
        }
      },
      {
        name: 'longitude',
        label: "Longitude",
        options: {
          searchable: false,
          filter: false,
          display: false
        }
      },
      {
        name: 'latitude',
        label: "Latitude",
        options: {
          searchable: false,
          filter: false,
          display: false
        }
      },
    ];
    const selectedIndex = data.findIndex((d, i)=> {return d.event_id === selected})

    const currentPage = (index, rowsPerPage)=>{
      if (index === -1){return 0}
      return Math.floor((selectedIndex+ 1)/ rowsPerPage)

    }

    // console.log(selectedIndex)
// KNOWN ISSUE: mui-datatables does not refresh on update of page or rowsPerPage options:
//      https://github.com/gregnb/mui-datatables/issues/957
    const options = {
      page:currentPage(selectedIndex, rowsPerPage),
      elevation: 0,
      count: data.length,
      filter: true,
      filterType: "checkbox",
      onRowClick: onClick,
      print: false,
      // responsive: "scroll",
      responsive: "stacked",
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 20, 30, 40],
      selectableRows: 'single',
      rowsSelected: [selectedIndex],
      isRowSelectable: (e)=>false,
    };

    return (
      <MuiThemeProvider theme={this.state.theme}>
        {}
        <MUIDataTable
          data={data}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/TableSearch.js